<!-- @format -->

<template>
	<el-dialog v-model="dialogVisible" :title="title" @open="getFormData" @close="closeDialog">
		<inner-message
			:id="id"
			ref="innerMessage"
			:detail-data="detailData"
			:inside="inside"
			:readonly="readonly"
			@callback="handleCallback"
		/>
	</el-dialog>
</template>
<script>
	import InnerMessage from './index';
	export default {
		components: {
			InnerMessage,
		},
		props: {
			inside: {
				type: Boolean,
				default: false,
			},
			visible: {
				type: Boolean,
				default: false,
			},
			readonly: {
				type: Boolean,
				default: false,
			},
			detailData: {
				type: Object,
			},
			id: String,
			title: String,
		},
		data() {
			return {
				dialogVisible: this.visible,
				dialogLoading: false,
			};
		},
		watch: {
			visible: {
				handler() {
					this.dialogVisible = this.visible;
				},
				immediate: true,
			},
		},

		methods: {
			// 关闭当前窗口
			closeDialog() {
				this.$emit('callback', true);

				this.$emit('close', false);
			},
			/**
			 * 获取表单数据
			 */
			getFormData() {
				this.$nextTick(() => {
					this.$refs.innerMessage.getFormData();
				});
			},
		},
	};
</script>
<style lang="scss">
	.inner-dialog {
		.list {
			.el-form-item__content {
				margin-left: 0px !important;

				.el-table--border {
					height: 300px !important;
				}
			}
		}

		.ibps-container-crud__header {
			display: none;
		}
	}
</style>
